export default [
  {
    path: "/module-field-management/:moduleHash",
    name: "module-field-management",
    component: () =>
      import("@/views/module-field-management/list/ModuleFieldList.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Campos" },
        { title: "Lista", active: true }
      ],
      pageTitle: "Módulos",
      rule: "admin"
    }
  },
  {
    path: "/module-actions/:moduleHash",
    name: "module-actions",
    component: () => import("@/views/module-actions/ModuleActionsList.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "User" },
        { title: "List", active: true }
      ],
      pageTitle: "Ações",
      rule: "editor"
    }
  },
  {
    path: "/module-actions/add/:moduleHash",
    name: "module-actions",
    component: () => import("@/views/module-actions/ModuleActionsAdd.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "User" },
        { title: "List", active: true }
      ],
      pageTitle: "Ações",
      rule: "editor"
    }
  },
  {
    path: "/module-actions/edit/:moduleHash/:actionHash",
    name: "module-actions",
    component: () => import("@/views/module-actions/ModuleActionsEdit.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Module Actions" },
        { title: "List", active: true }
      ],
      pageTitle: "Ações",
      rule: "editor"
    }
  },
  {
    path: "/module-field-management-calendar/:moduleHash",
    name: "module-field-management-calendar",
    component: () =>
      import(
        "@/views/module-field-management-calendar/list/ModuleFieldList.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Campos" },
        { title: "Lista", active: true }
      ],
      pageTitle: "Módulos",
      rule: "admin"
    }
  },
  {
    path: "/menu-builder",
    name: "menu-builder",
    component: () => import("@/views/menu-builder/MenuBuilder.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Construtor de Menu" },
        { title: "Editar", active: true }
      ],
      pageTitle: "Construtor de Menu",
      rule: "admin"
    }
  },
  {
    path: "/module-list-management/:moduleHash/:listHash?/:redirectUrl?",
    name: "module-list-management",
    component: () => import("@/views/module-list-management/list/List.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Módulos", url: "/module-management" },
        { title: "Listas", active: true }
      ],
      pageTitle: "Listas",
      rule: "editor"
    }
  },
  {
    path: "/module-management",
    name: "module-management",
    component: () => import("@/views/module-management/list/ModuleList.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Módulos" },
        { title: "Lista", active: true }
      ],
      pageTitle: "Módulos",
      rule: "admin"
    }
  },
  {
    path: "/dashboard-management",
    name: "dashboard-management",
    component: () =>
      import("@/views/dashboard-management/list/DashboardList.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Dashboards" },
        { title: "Lista", active: true }
      ],
      pageTitle: "Dashboards",
      rule: "admin"
    }
  },
  {
    path: "/module-management/add",
    name: "module-management-add",
    component: () =>
      import("@/views/module-management/module-management-add/ModuleAdd.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Módulos", url: "/module-management" },
        { title: "Adicionar", active: true }
      ],
      pageTitle: "Módulos",
      rule: "admin"
    }
  },
  {
    path: "/module-management/edit/:moduleHash",
    name: "module-management-edit",
    component: () =>
      import("@/views/module-management/module-management-edit/ModuleEdit.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Módulos", url: "/module-management" },
        { title: "Editar", active: true }
      ],
      pageTitle: "Módulos",
      rule: "admin"
    }
  },
  {
    path: "/module-management/view/:moduleHash",
    name: "module-management-view",
    component: () =>
      import("@/views/module-management/module-management-view/ModuleView.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Módulos", url: "/module-management" },
        { title: "Editar", active: true }
      ],
      pageTitle: "Módulos",
      rule: "admin"
    }
  }
];

